import styled from "styled-components";

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px
`

export const TextWithHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px
`

export const SubHeading = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  color: #8F38EF;
`

export const PointContainer = styled.ul`
  padding-left: 1rem;
`

export const Point = styled.li`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

export const NumberedPoint = styled.ol`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding-left: 0rem;
`

export const StyledLink = styled.a`
  color: #8F38EF;
  text-decoration: underline;
  cursor: pointer;
`